import React, { FC } from 'react'

import { Toggle } from '@style-port/roov-ui-components-react'
import { Txt } from 'src/components/atoms'

import { useError, useGlobalLoading, useIpRestriction, useToast } from 'src/hooks'

type Props = {
  enabled: boolean
  hasAllowedIp: boolean
  afterUpdate: () => void
  className?: string
}

export const IpRestrictionToggle: FC<Props> = ({
  enabled,
  hasAllowedIp,
  afterUpdate,
  className,
}) => {
  const { showGlobalLoading, hideGlobalLoading } = useGlobalLoading()
  const { updateIpRestriction } = useIpRestriction()
  const { toErrorEntities } = useError()
  const { displayStandardTextToast, displayErrorTextToast } = useToast()

  const handleOnChange = async (newValue: boolean) => {
    showGlobalLoading()

    try {
      await updateIpRestriction(newValue)
      displayStandardTextToast('アクセス制限を更新しました')
      afterUpdate()
    } catch (error) {
      const errors = toErrorEntities(error)
      console.log('errors: ', errors)
      displayErrorTextToast('アクセス制限の更新に失敗しました')
    } finally {
      hideGlobalLoading()
    }
  }

  return (
    <div className={className}>
      <div className="tw-centering">
        <Txt className="tw-mr-s-1 tw-text-roovPrimary-default tw-font-bold">
          許可IPアドレス以外からのアクセスを制限
        </Txt>
        <Toggle enabled={enabled} disabled={!hasAllowedIp} onChange={handleOnChange} />
      </div>
    </div>
  )
}
